import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from './home/HeroSection';
// VERSION 1: SearchSection commented out - moved to dedicated /search page
// import SearchSection from './home/SearchSection';
import LandSections from './home/LandSections';
import WhyLandLayout from './home/WhyLandLayout';
import LandTypes from './home/LandTypes';
import MonitorLandCTA from './home/MonitorLandCTA';

const Homepage = () => {
  const location = useLocation();
  // VERSION 1: searchSectionRef no longer needed
  // const searchSectionRef = useRef(null);

  // VERSION 1: Scroll to search logic removed - search is now a separate page
  // useEffect(() => {
  //   const shouldScrollToSearch = location?.state?.scrollToSearch;
  //   const shouldScrollFeatured = location?.hash === '#featured' || location?.state?.scrollToFeatured;
  //   const shouldScrollTop = location?.state?.scrollToTop;
  //
  //   if (shouldScrollFeatured) {
  //     // Scroll to FeaturedLands anchor
  //     setTimeout(() => {
  //       const anchor = document.querySelector('[data-listings-anchor]');
  //       if (anchor) {
  //         const y = anchor.getBoundingClientRect().top + window.pageYOffset - 70; // keep a little space below header
  //         window.scrollTo({ top: y, behavior: 'smooth' });
  //       }
  //     }, 80);
  //     return; // skip other logic if featured requested
  //   }
  //
  //   if (shouldScrollToSearch || shouldScrollTop) {
  //     setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 50);
  //     if (window.history?.replaceState) {
  //       const { pathname, hash, search } = window.location;
  //       window.history.replaceState(null, '', pathname + search + (hash || ''));
  //     }
  //   }
  // }, [location]);

  // Scroll to featured when navigated with #featured or state
  useEffect(() => {
    const shouldScrollFeatured = location?.hash === '#featured' || location?.state?.scrollToFeatured;

    if (shouldScrollFeatured) {
      // Scroll to FeaturedLands anchor
      setTimeout(() => {
        const anchor = document.querySelector('[data-listings-anchor]');
        if (anchor) {
          const y = anchor.getBoundingClientRect().top + window.pageYOffset - 70; // keep a little space below header
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 80);
    }
  }, [location]);

  // VERSION 1: Scroll detection removed - search button now navigates to /search page
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const searchElement = document.getElementById('search');
  //     if (!searchElement) {
  //       // If search element not found yet, retry after a short delay
  //       setTimeout(handleScroll, 100);
  //       return;
  //     }
  //
  //     const rect = searchElement.getBoundingClientRect();
  //     const viewportHeight = window.innerHeight;
  //
  //     // Consider search visible if it's in the upper half of viewport
  //     const isSearchVisible = rect.top < viewportHeight * 0.5 && rect.bottom > 0;
  //
  //     // Update body data attribute to control search button state
  //     if (isSearchVisible) {
  //       // Search section is visible, mark as active
  //       document.body.dataset.onSearch = 'true';
  //     } else {
  //       // User scrolled away from search, deactivate
  //       document.body.dataset.onSearch = 'false';
  //     }
  //   };
  //
  //   // Add scroll listener
  //   window.addEventListener('scroll', handleScroll, { passive: true });
  //   // Initial check with slight delay to ensure DOM is ready
  //   setTimeout(handleScroll, 50);
  //
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, [location.hash, location.pathname]);

  return (
    <div className="homepage">
      <HeroSection />
      {/* VERSION 1: Search box commented out - moved to dedicated /search page */}
      {/* <div className="relative -mt-24 md:-mt-52 lg:-mt-60 z-20" ref={searchSectionRef}>
        <SearchSection />
      </div> */}

      {/* Content sections with negative margin for overlap */}
      <div className="relative -mt-[25vh] md:-mt-[28vh] lg:-mt-[30vh] pt-16 md:pt-20 lg:pt-24">
        {/* Land sections: New Lands, Top Viewed, All Lands */}
        <div id="featured">
          <LandSections />
        </div>

        {/* Reels Circular Badges - shows after featured lands */}
        {/* <ReelsSection /> */}

        <div style={{ contentVisibility: 'auto', containIntrinsicSize: '900px' }}>
          <WhyLandLayout />
        </div>
        <div style={{ contentVisibility: 'auto', containIntrinsicSize: '1400px' }}>
          <LandTypes />
        </div>
        <div style={{ contentVisibility: 'auto', containIntrinsicSize: '360px' }}>
          <MonitorLandCTA />
        </div>
      </div>
      {/* <FeaturedLayouts /> */}
      {/* <Testimonials /> */}
    </div>
  );
};

export default Homepage;
